module.exports = __webpack_public_path__ + "static/media/thumbnail.67321e32.jpg";